export const getFilteredItems = (
  items: any[],
  slotOptions: any[],
  filterOptions: Record<string, any> // { material: [ value: "WOOD", isActive: true ], ... }
): any[] =>
  items.filter(
    (item) =>
      slotOptions.some((option) => option.item === item.item) &&
      Object.entries(slotOptions.find((option: any) => option.item === item.item).deniedProperties).every(
        ([key, deniedValues]: any) => {
          if (item.props[key] !== undefined) {
            return !deniedValues.some((val: any) => val.toString() === item.props[key].toString())
          } else {
            return true
          }
        }
      ) &&
      (!filterOptions ||
        (item.erpItemNumber === null && item.props.kind === 'None') ||
        Object.entries(filterOptions).every(([key, arr]) => {
          const activeValues = arr.filter((valueObj: any) => valueObj.isActive)
          if (activeValues.length === 0) {
            return true
          }
          return activeValues.some(
            (valueObj: any) => item._filterProperties && item._filterProperties[key] === valueObj.value
          )
        }))
  )
